document.addEventListener('DOMContentLoaded', () => {
  normalizeProductPageHeadings();
});

function normalizeProductPageHeadings() {
  const mainTitle = document.querySelector('.product-main-title');
  const mainTitleText = mainTitle ? mainTitle.textContent.replace(/\s+/g, ' ').trim() : '';

  document.querySelectorAll('h1').forEach((heading) => {
    if (heading === mainTitle) return;
    if (mainTitle && heading.textContent.replace(/\s+/g, ' ').trim() === mainTitleText) {
      replaceHeadingTag(heading, 'p', 'product-main-title-duplicate');
      return;
    }
    replaceHeadingTag(heading, 'h2');
  });

  document.querySelectorAll('h2, h3, h4, h5, h6').forEach((wrapper) => {
    wrapper.querySelectorAll(':scope > h1').forEach((nestedHeading) => {
      replaceHeadingTag(nestedHeading, 'h2');
    });
  });

  document
    .querySelectorAll('.description-accordion .collapsible__content h1, .description-accordion .collapsible__content h2')
    .forEach((heading) => {
      replaceHeadingTag(heading, 'h3');
    });

  document.querySelectorAll('.description-accordion .collapsible__heading').forEach((heading) => {
    if (heading.tagName !== 'H2') {
      replaceHeadingTag(heading, 'h2');
    }
  });
}

function replaceHeadingTag(node, tagName, className) {
  if (!node || node.tagName.toLowerCase() === tagName.toLowerCase()) return;
  const replacement = document.createElement(tagName);
  replacement.innerHTML = node.innerHTML;
  Array.from(node.attributes).forEach((attr) => {
    replacement.setAttribute(attr.name, attr.value);
  });
  if (className) {
    replacement.classList.add(className);
  }
  node.replaceWith(replacement);
}
